export default __webpack_public_path__ + "static/step_1_en-ef2ecbc6e9067337839d046ffd8420fd.svg";